(function () {

  function setSparkProductCardStyles() {
    var hosts = document.querySelectorAll('spark-product-card');
    hosts.forEach(function (host) {
      setTimeout(function () {
        setShadowStyles(host, `
        /* Hide ONLY RRP elements - be specific, don't hide the main price */
        .product-rrp-price,
        p.product-rrp-price {
          display: none !important;
        }
        
        /* Reduce spacing in product info */
        .spark-product-info {
          margin-top: 0 !important;
          padding-top: 0 !important;
        }
        
        /* Make price wrapper flex for horizontal layout */
        .product-price-wrapper {
          display: flex !important;
          align-items: center !important;
          column-gap: 5px !important;
          margin-top: 0 !important;
        }
        
        /* Add label before the main price */
        .product-price::before {
          content: 'מחיר לאחר הנחה';
          font-size: 15px;
        }
        
        .product-price {
          margin: 0 !important;
        }`);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setSparkProductCardStyles);
  } else {
    setSparkProductCardStyles();
  }

  function setShadowStyles(host, css) {
    if (!host) {
      console.warn('setShadowStyles: host is not provided');
      return;
    }

    // SparkLayer components already have shadow roots - NEVER try to create a new one
    var root = host.shadowRoot;
    if (!root) {
      console.warn('setShadowStyles: no shadowRoot on host', host);
      return;
    }

    var supportsConstructible = typeof CSSStyleSheet !== 'undefined' &&
      'replaceSync' in CSSStyleSheet.prototype &&
      'adoptedStyleSheets' in root;

    if (supportsConstructible) {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
      root.adoptedStyleSheets = (root.adoptedStyleSheets || []).concat(sheet);
    } else {
      var style = document.createElement('style');
      style.textContent = css;
      root.prepend(style);
    }
  }
  var gsInitDone = false;

  function initGiftshipDefaults() {
    var items = document.querySelectorAll('.gs__toggle-feature-item');
    if (!items.length) return;

    items.forEach(function (el) {
      el.classList.remove('gs__collapsed');
    });

    document.querySelectorAll('.gs__gift-checkbox').forEach(function (cb) {
      if (!cb.checked) {
        cb.checked = true;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    gsInitDone = true;
    gsObserver.disconnect();
  }

  var gsObserver = new MutationObserver(function () {
    if (!gsInitDone) initGiftshipDefaults();
  });

  gsObserver.observe(document.body, { childList: true, subtree: true });
})();
